import { useCallback } from 'react'
import { useFormikContext } from 'formik'
import { SearchInput } from '@user/store/search/typings'

type Props = {
  ref: React.RefObject<HTMLInputElement>
  onClose?: () => void
  topSearch: string
}

export function useHandlers(props: Props) {
  const { ref, onClose, topSearch } = props

  const { setFieldValue } = useFormikContext<SearchInput>()

  const onClickSearch = useCallback(() => {
    if (onClose) {
      onClose()
    }
  }, [onClose])

  const onClickClear = useCallback(() => {
    if (!topSearch?.trim()) {
      if (onClose) {
        onClose()
      }
    } else {
      setFieldValue('topSearch', '')
      ref.current?.focus()
    }
  }, [ref, setFieldValue, topSearch, onClose])

  const onKeyDown = useCallback(
    ({ key }: React.KeyboardEvent<unknown>) => {
      if (key === 'Escape' && !topSearch?.trim() && onClose) {
        onClose()
      }
    },
    [topSearch, onClose],
  )

  return {
    onClickSearch,
    onClickClear,
    onKeyDown,
  }
}
